<!-- 设置月卡类型计费规则接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: { "parkCode":"2KNTYVWC","vipTypeCode":"001","chargeGroupCode":"002"},
            responseCode: 	{
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台对指定月卡类型设置计费规则",
                t_url: this.commonUrls.test+"setVipChargeRule",
                p_url: this.commonUrls.prod+"setVipChargeRule",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号，目前只支持一个停车场，对停车场管理系统VIP类型有多个停车场权限情况，未指定的停车场设置对应停车场默认计费规则' },
                        { info1: 'vipTypeCode', info2: '否', info3: 'String', info4: '月卡类型编号' },
                        { info1: 'vipTypeName', info2: '否', info3: 'String', info4: '月卡类型名称，月卡类型编号和名称二选一，如果都传，以编号为准' },
                        { info1: 'chargeGroupCode', info2: '是', info3: 'String', info4: '计费组编号' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/vip/setVipChargeRule.vue